/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Psm_BlockInputs */



/**
* | output |
* | --- |
* | "Text Block (Recommended)" |
*
* @param {Ocr_Psm_BlockInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_psm_block = /** @type {((inputs?: Ocr_Psm_BlockInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Psm_BlockInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bloc de texte (recommandé)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Textblock (Empfohlen)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Blocco di testo (consigliato)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текстовый блок (рекомендуется)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bloque de texto (recomendado)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本块（推荐）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストブロック（推奨）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट ब्लॉक (अनुशंसित)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Bloco de texto (recomendado)")
	return /** @type {LocalizedString} */ ("Text Block (Recommended)")
});